export default __webpack_public_path__ + "static/media/about.8f6d1fe9.webp";